import { useQuery } from "react-query";
import { range } from "utils/number";
import * as summariesService from "api/services/summaryService";

/**
 * Store server's state of projects years range
 *
 * @param {summariesService.SummaryType} summaryType
 * @returns The query object returned by the useQuery hook
 */
export const useYearsRange = (summaryType) =>
  useQuery(["yearsRange"], () => summariesService.getYearsRange(summaryType), {
    select: ({ data }) => range(data.startYear, data.endYear),
    refetchOnWindowFocus: false,
  });

/**
 * Store server's state of projects years range
 *
 * @param {summariesService.SummaryType} summaryType
 * @returns The query object returned by the useQuery hook
 */
export const useYearsRangeWithProjectCount = (summaryType) =>
  useQuery(["yearsRange"], () => summariesService.getYearsRange(summaryType), {
    select: ({ data }) => ({
      years: range(data.startYear, data.endYear),
      noDatesProjectCount: data.noDatesProjectCount,
    }),
    refetchOnWindowFocus: false,
  });
